
import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogFooter, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';
import { Organization } from './UserFilters';

interface InviteUserDialogProps {
  isOpen: boolean;
  organizations: Organization[];
  inviteData: {
    email: string;
    organization: string;
  };
  onClose: () => void;
  onInviteDataChange: (data: { email: string; organization: string }) => void;
  onSendInvite: () => void;
}

const InviteUserDialog: React.FC<InviteUserDialogProps> = ({
  isOpen,
  organizations,
  inviteData,
  onClose,
  onInviteDataChange,
  onSendInvite
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Invite User</DialogTitle>
          <DialogDescription>
            Send an invitation email to a new user.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email Address *</Label>
            <Input
              id="email"
              type="email"
              placeholder="user@example.com"
              value={inviteData.email}
              onChange={(e) => onInviteDataChange({ ...inviteData, email: e.target.value })}
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="organization">Organization *</Label>
            <Select
              value={inviteData.organization}
              onValueChange={(value) => onInviteDataChange({ ...inviteData, organization: value })}
            >
              <SelectTrigger id="organization">
                <SelectValue placeholder="Select organization" />
              </SelectTrigger>
              <SelectContent>
                {organizations.map(org => (
                  <SelectItem key={org.id} value={org.id}>
                    {org.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSendInvite}>
            Send Invitation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InviteUserDialog;
